/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { importAuctionStartingBidCsv } from '../fn/csv-import/import-auction-starting-bid-csv';
import { ImportAuctionStartingBidCsv$Params } from '../fn/csv-import/import-auction-starting-bid-csv';
import { importLotsCsv } from '../fn/csv-import/import-lots-csv';
import { ImportLotsCsv$Params } from '../fn/csv-import/import-lots-csv';

@Injectable({ providedIn: 'root' })
export class GeneratedCsvImportService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `importAuctionStartingBidCsv()` */
  static readonly ImportAuctionStartingBidCsvPath = '/api/csv-import/auction-starting-bids';

  /**
   * Imports a list of starting bids per lot for a given auction.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `importAuctionStartingBidCsv()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  importAuctionStartingBidCsv$Response(params: ImportAuctionStartingBidCsv$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return importAuctionStartingBidCsv(this.http, this.rootUrl, params, context);
  }

  /**
   * Imports a list of starting bids per lot for a given auction.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `importAuctionStartingBidCsv$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  importAuctionStartingBidCsv(params: ImportAuctionStartingBidCsv$Params, context?: HttpContext): Observable<void> {
    return this.importAuctionStartingBidCsv$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `importLotsCsv()` */
  static readonly ImportLotsCsvPath = '/api/csv-import/lots';

  /**
   * Imports a list of lots for a given auction.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `importLotsCsv()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  importLotsCsv$Response(params: ImportLotsCsv$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return importLotsCsv(this.http, this.rootUrl, params, context);
  }

  /**
   * Imports a list of lots for a given auction.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `importLotsCsv$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  importLotsCsv(params: ImportLotsCsv$Params, context?: HttpContext): Observable<void> {
    return this.importLotsCsv$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
